import React from 'react';
import { CTAButton } from './CTAButton';
export function AuthorSection() {
  return <section className="bg-cream-light py-[100px] px-5" data-id="element-22">
      <div className="max-w-[760px] mx-auto" data-id="element-23">
        <div className="text-center mb-12" data-id="element-24">
          <p className="font-sans text-[11px] font-bold tracking-[0.3em] text-gold-accent uppercase mb-4" data-id="element-25">
            WHY THIS SYSTEM EXISTS
          </p>
          <h2 className="font-serif text-[32px] md:text-[40px] text-primary-dark leading-tight" data-id="element-26">
            Roderic Built This System
            <br data-id="element-27" />
            Because He Had No Other Choice
          </h2>
        </div>

        {/* Author portrait */}
        <div className="flex justify-center mb-12" data-id="element-28">
          <div className="w-[180px] h-[180px] md:w-[220px] md:h-[220px] rounded-full overflow-hidden border-[4px] border-gold-accent/30 shadow-[0_8px_30px_rgba(0,0,0,0.12)]" data-id="element-29">
            <img src="https://cdn.magicpatterns.com/uploads/5HnACv1XGYAG5895SW9LUJ/heylloyd-image-1774830595029.png" alt="Roderic — Founder of GoDeskCore / PROSPERA" className="w-full h-full object-cover object-top" data-id="element-30" />
          </div>
        </div>

        <div className="font-sans text-[18px] text-primary-dark leading-[2] mb-12" data-id="element-31">
          <p className="mb-6" data-id="element-32">Three years ago, I woke up in a hospital bed.</p>
          <p className="mb-6" data-id="element-33">
            Six coronary bypasses. Emergency surgery. I was 48 hours away from
            not waking up at all.
          </p>
          <p className="mb-6" data-id="element-34">
            When the anesthesia wore off, two things hit me simultaneously:
          </p>
          <p className="mb-6 pl-4 border-l-2 border-primary-dark/10" data-id="element-35">
            I was alive.
            <br data-id="element-36" />
            <br data-id="element-37" />
            And I had $40,000 in medical debt — not because I was uninsured or
            unprepared. I had good coverage. That number came entirely from
            deductibles, out-of-pocket maximums, and gaps the policy didn't
            mention until the bills arrived.
          </p>
          <p className="mb-6" data-id="element-38">
            I had a job. I paid my bills on time. I wasn't reckless. I wasn't
            irresponsible.
          </p>
          <p className="mb-6 font-bold" data-id="element-39">
            I just had no system for what came next.
          </p>
          <p className="mb-6" data-id="element-40">
            No framework for which debt to attack first. No script for the calls
            I needed to make. No roadmap for the decisions that had to happen in
            the right order.
          </p>
          <p data-id="element-41">
            I looked for a book that would give me all of that. Not inspiration.
            Not philosophy. A field manual.
          </p>
        </div>

        <div className="max-w-[600px] mx-auto mb-12" data-id="element-42">
          <blockquote className="font-serif italic text-[24px] md:text-[28px] text-gold-accent border-l-[4px] border-gold-accent pl-8 leading-relaxed" data-id="element-43">
            "It didn't exist. So I built it."
          </blockquote>
        </div>

        <div className="max-w-[600px] mx-auto text-center mb-12" data-id="element-44">
          <p className="font-serif text-[26px] md:text-[30px] text-primary-dark leading-snug" data-id="element-45">
            Nobody struggling with debt lacks discipline.
            <br data-id="element-46" />
            <span className="italic text-gold-accent" data-id="element-47">
              They lack a field manual. This is the field manual.
            </span>
          </p>
        </div>

        <div className="text-center mb-10" data-id="element-48">
          <p className="font-sans text-[14px] text-primary-dark/50" data-id="element-49">
            — Roderic · Founder, GoDeskCore / PROSPERA
          </p>
        </div>

        <div className="flex justify-center" data-id="element-50">
          <CTAButton subText="Built from real debt · Tested in real life" data-id="element-51">
            SHOW ME THE FIELD MANUAL → $9.99
          </CTAButton>
        </div>
      </div>
    </section>;
}